// extracted by mini-css-extract-plugin
export default {"dataGridContainer":"styles_dataGridContainer__xNLXr","wrapper":"styles_wrapper__qwOqZ","title":"styles_title__SG2fU","grid":"styles_grid__svfoG"};